'use client'
import { CustomMessage } from '@/components/CustomMessage';
import { isEmpty } from '@/libs/utils/text';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {

  return (
    <>
      <CustomMessage severity='error' text={isEmpty(error?.message) ? 'Ops. Algo deu errado!' : error?.message} />

      <hr />
      <p className='mt-4 text-center'>
        <Link href={"/portal/login"}>Voltar</Link>
      </p>
    </>
  )
}